exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".sign-out[data-v-6dde423b] {\n  text-decoration: none;\n}", ""]);

// exports
